export default {
      id: "nuit-claire-usage",
      viewBox: "0 0 91 91",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#nuit-claire-usage",
      toString: function () {
        return this.url;
      }
    }